<template>
  <div class="wt2-radio-text" :class="{ '-disabled': disabled }">
    <slot name="header"></slot>
    <div class="-radio-text-box">
      <div class="-radio-buttons" :style="{ height: height + 'px' }">
        <div
          class="-button"
          :class="{
            '-disabled': disabled || button.disabled,
            '-active': isActive(button),
            '-full': isActive(button) && full,
          }"
          v-for="button in normalizeButtons"
          :key="button.value"
          :title="button.title || button.text"
          @click="updateValue(button.value)"
        >
          <template v-if="button.icon">
            <span class="wticon" :class="button.icon"></span>
            <span v-if="button.showBoth">{{ button.text }}</span>
          </template>
          <span v-else>{{ button.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import radioMixin from './mixins/radioMixin.vue';

export default {
  props: {
    full: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 30,
    },
  },

  methods: {
    isActive(button) {
      return !this.disabled && button.value === this.curValue;
    },
  },

  mixins: [radioMixin],
};
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.wt2-radio-text {
  display: flex;
  &.-inline {
    display: inline-flex;
  }
  flex-direction: column;
  width: 100%;

  &.-disabled {
    opacity: 0.5;
  }

  .-radio-text-box {
    .-radio-buttons {
      display: flex;
      justify-content: space-between;

      .-button {
        position: relative;
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        border: 1px solid $color-black-l;
        border-right: 0;
        &:last-child {
          border-right: 1px solid $color-black-l;
        }
        cursor: pointer;
        transition: all 0.2s;

        span {
          font-size: $font-size-s;
          font-weight: $font-weight-regular;
          display: block;
          transition: color 0.2s;
          white-space: nowrap;
          line-height: 0;

          &.wticon {
            font-size: 16px;
            & + span {
              margin-left: 5px;
            }
          }
        }

        &.-disabled {
          color: $color-disabled;
          pointer-events: none;
        }

        &:hover:not(.-disabled),
        &.-active {
          z-index: 1;
          border: 1px solid $color-primary;
          border-right: 0;
          &:last-child {
            border-right: 1px solid $color-primary;
          }

          & + .-button {
            border-left: 1px solid $color-primary;
          }

          span {
            color: $color-primary;
          }
        }

        &.-active.-full {
          background-color: $color-primary;
          span {
            color: $color-white;
          }
        }
      }
    }
  }
}
</style>
